import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';
import { getSessionRequestHeaders } from './requestHeaders';

type ScopedRequestOptions = RequestOptions;

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return async <T = unknown>(url: string, options?: ScopedRequestOptions) => {
    const requestOptions = options || {};
    const headers = await getSessionRequestHeaders(
      url,
      requestOptions.headers as Record<string, string> | undefined,
    );

    return (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...requestOptions,
      headers,
    });
  };
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);
export const createTenantManagementRequest = () =>
  createRequest(BizAppConfig.appTenantManagementUrl);
